<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Proposals</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="col-xl-12">
        <card v-loading="loading">
          <div slot="header" class="row align-items-center">
            <div class="col-4">
              <h3 class="mb-0">Create Proposal</h3>
            </div>
          </div>
          <new-proposal-form
            :lead="lead"
            :lead-event="leadEvent"
            :shortlists="shortlists"
            :lead-event-id="leadEventId"
            :submitting="submitting"
            @submitRequest="submitRequest"
          />
        </card>
      </div>
    </div>

    <modal
      :show.sync="modalConfirmation"
      body-classes="p-0"
      modal-classes="modal-dialog-centered modal-sm"
    >
      <card
        type="secondary"
        shadow
        header-classes="bg-white pb-5"
        body-classes="px-lg-5 py-lg-5"
        class="border-0"
      >
        <template>
          <div class="text-center mb-3">
            <h5 class="modal-title">Sending Proposal</h5>
          </div>
        </template>
        <template>
          <div class="text-center container-btn">
            <div class="mt-3 mb-3" v-loading="loading"></div>
            <span v-if="!loading">
              <p class="text-muted small">Your proposal has been submitted.</p>
              <base-button type="secondary" @click="completeClose()">
                Return to Lead Details
              </base-button>
            </span>
          </div>
        </template>
      </card>
    </modal>
  </div>
</template>

<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import NewProposalForm from "@/views/Widgets/Proposals/NewProposalForm";
import ProposalService from "@/services/proposal.service";
import LeadEventService from "@/services/lead-event.service";

export default {
  components: {
    RouteBreadCrumb,
    [NewProposalForm.name]: NewProposalForm,
  },
  data() {
    return {
      leadId: parseInt(this.$route.params.id),
      leadEventId: parseInt(this.$route.params.eventId),
      modalConfirmation: false,
      shortlists: [],
      submitting: false,
      loading: false,
    };
  },
  async created() {
    this.loading = true;
    await this.$store.dispatch("leads/getSingle", { id: this.leadId });
    await this.$store.dispatch("leadEvent/getSingle", this.leadEventId);
    // await this.$store.dispatch("shortlist/getShortlist", this.leadEventId);
    this.loading = false;
  },
  async mounted() {
    const venues = await LeadEventService.getProposalQualifiedVenues(this.leadEventId);
    this.shortlists = venues;
  },
  computed: {
    lead() {
      return this.$store.getters["leads/getLeadById"](this.leadId);
    },
    leadEvent() {
      return this.$store.getters["leadEvent/getLeadEventsById"](this.leadEventId);
    }
  },
  methods: {
    getProposalSubmitErrorMessage(err) {
      const responseData = err?.response?.data;

      if (responseData?.errors && typeof responseData.errors === "object") {
        const validationMessages = Object.values(responseData.errors)
          .reduce((acc, value) => {
            if (Array.isArray(value)) {
              return acc.concat(value);
            }
            if (value) {
              acc.push(value);
            }
            return acc;
          }, [])
          .map((message) => String(message).trim())
          .filter(Boolean);

        if (validationMessages.length) {
          return validationMessages.join(" ");
        }
      }

      if (responseData?.message) {
        return responseData.message;
      }

      if (responseData?.error?.message) {
        return responseData.error.message;
      }

      if (err?.message) {
        return err.message;
      }

      return "Failed to submit proposal. Please check required fields and try again.";
    },
    async submitRequest(formData) {
      this.submitting = true;
      this.loading = true;
      try {
        await ProposalService.sendProposal(this.leadEventId, formData);
        this.modalConfirmation = true;
      } catch (err) {
        const errorMessage = this.getProposalSubmitErrorMessage(err);
        this.$store.dispatch('alert/error', errorMessage, { root: true });
      } finally {
        this.submitting = false;
        this.loading = false;
      }
    },
    completeClose() {
      this.modalConfirmation = false;
      this.$router.push({ name: "LeadDetails", params: { id: this.leadId } });
    },
  },
};
</script>

<style lang="scss">
.container-btn {
  margin-top: 40px;
}
</style>
